export const shareColor = "#ffa44e";

export const whatsapp = "https://wa.me/message/UT75HJAPZQ5CL1";
export const telegram = "https://t.me/+eOeybHFjhcJhMDhk";
export const tiktok = "https://www.tiktok.com/@hgppeps?";
export const instagram =
  "https://www.instagram.com/hgppeps?igsh=dTJjOWs0N2E4bTFt&utm_source=qr";
